import * as blog from './blog';
import * as checkout from './checkout';
import * as clubs from './clubs';
import * as general from './general';
import * as modalCart from './modalCart';
import * as navigation from './navigation';
import * as photoGallery from './photoGallery';
import * as products from './products';
import * as userTools from './userTools';
import * as video from './video';
import * as v65Customizations from './v65Customizations';

const onLoadRecalculations = () => {
  navigation.scrollHeaderNav();
  checkout.init();
};

window.addEventListener('load', onLoadRecalculations, false);

// Resize functions
let resizeStart = new Date();
let timeout = false;
const delay = 200;

const resizeEnd = () => {
  if ((new Date() - resizeStart) < delay) {
    setTimeout(resizeEnd, delay);
  } else {
    // Add any scripts that need to trigger on end of window resize here
    timeout = false;
    navigation.scrollHeaderNav();
    checkout.init();
  }
};

window.addEventListener('resize', () => {
  resizeStart = new Date();

  navigation.scrollHeaderNav();
  navigation.scrollSecondaryNav();
  checkout.init();
  video.triggerQueuedVideos();

  if (timeout === false) {
    timeout = true;
    setTimeout(resizeEnd, delay);
  }
}, false);

window.addEventListener('scroll', navigation.scrollHeaderNav, false);

userTools.init();
general.init();
v65Customizations.init();

blog.init();
checkout.init();
clubs.init();
modalCart.init();
navigation.init();
products.init();
photoGallery.init();
video.init();



// WEBPACK FOOTER //
// ./src/assets/js/app.js